module.exports = __webpack_public_path__ + "static/donate_bg-2b20bccfee9db55ab08465bf6f393832.webp";